import { ThermalDataType } from "../../interface/dataTypeInterface";

export const thermalData: ThermalDataType[] = [
  {
    id: "thermal_properties_building_insulating_24C",
    name: "thermal Properties of building and isulating material (at 24°C)",
    updatedAt: "2022-07-26",
    data: [
      {
        material: { value: "building board" },
        description: { value: "abestos-cement board, 6mm" },
        density: { value: 1922, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 93.7, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "building board" },
        description: { value: "gypsum or plasterboard, 10mm" },
        density: { value: 800, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 17.6, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "building board" },
        description: { value: "plywood, 10mm" },
        density: { value: 545, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.12, unit: "W/(mK)" },
        unit_conductance: { value: 12.1, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "building board" },
        description: {
          value: "insulating board and sheathing, regular density, 13mm",
        },
        density: { value: 288, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 4.32, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "building board" },
        description: {
          value: "Hardboard, high-density, standard tempered",
        },
        density: { value: 1010, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.14, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "building board" },
        description: {
          value: "particleboard, medium density",
        },
        density: { value: 800, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.14, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "building board" },
        description: {
          value: "particleboard, underlayment, 16mm",
        },
        density: { value: 640, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 6.93, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "building board" },
        description: {
          value: "wood subfloor, 20mm ",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 6.02, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "building paper" },
        description: {
          value: "vapor-permeable felt",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 94.8, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "building paper" },
        description: {
          value: "vapor-seal, two layers of mopped felt",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 47.4, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "finish/flooring" },
        description: {
          value: "carpet and fibrous pad",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 2.73, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "finish/flooring" },
        description: {
          value: "carpet and rubber pad",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 4.6, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "finish/flooring" },
        description: {
          value: "tile-asphalt , linoleum, vinyl, or rubber",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 113, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "insulating materials" },
        description: {
          value: "mineral fiber - (form rock, slag, or glass), 50-70mm",
        },
        density: { value: "4.8 - 32", unit: "kg/m\u00b3" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 113, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "insulating materials" },
        description: {
          value: "cellular glass",
        },
        density: { value: 136, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.0548, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "insulating materials" },
        description: {
          value: "glass fiber, orgnaic bonded",
        },
        density: { value: "64 - 144", unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.036, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "insulating materials" },
        description: {
          value: "expanded polystyrene, molded beads",
        },
        density: { value: 16, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.04, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "insulating materials" },
        description: {
          value: "expanded polyurethane - R-11 expanded",
        },
        density: { value: 24, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.023, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "insulating materials" },
        description: {
          value: "mineral fiber with resin binder",
        },
        density: { value: 240, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.042, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "loose fill" },
        description: {
          value: "mineral fiber - rock, slag, or glass, 165-220mm",
        },
        density: { value: "9.6 - 32", unit: "kg/m\u00b3" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 0.45, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "loose fill" },
        description: {
          value: "silica aerogel",
        },
        density: { value: 122, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.025, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "loose fill" },
        description: {
          value: "vermiculite (expanded)",
        },
        density: { value: 122, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.068, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "roof insulation" },
        description: {
          value: "performed, for use above deck, 13mm",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 4.1, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "roof insulation" },
        description: {
          value: "cellular glass",
        },
        density: { value: 144, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.058, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "masonry materials, concretes" },
        description: {
          value: "lightweight aggregates",
        },
        density: { value: 3200, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.75, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "masonry materials, concretes" },
        description: {
          value: "expanded shale, clay, or slate",
        },
        density: { value: 1600, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.52, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "masonry materials, concretes" },
        description: {
          value: "expanded slags; cinders",
        },
        density: { value: 1280, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.36, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "masonry materials, concretes" },
        description: {
          value: "pumice; vermiculite",
        },
        density: { value: 640, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.17, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "masonry materials, concretes" },
        description: {
          value: "cellular concretes",
        },
        density: { value: 320, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.1, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "masonry materials, concretes" },
        description: {
          value: "sand and gravel or stone aggregate (not dried)",
        },
        density: { value: 2242, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 1.73, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "masonry units" },
        description: {
          value: "brick, common",
        },
        density: { value: 1922, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.72, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "masonry units" },
        description: {
          value: "brick, face",
        },
        density: { value: 2082, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 1.3, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "masonry units" },
        description: {
          value:
            "concrete blocks, three-oval core sand and gravel aggregate, 100mm",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 8.0, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "masonry units" },
        description: {
          value:
            "concrete blocks, lightweight aggregate (expanded shale, clay slate or slag; pumice), 100mm",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 3.8, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "plastering materials" },
        description: {
          value: "cemenent plaster, sand aggregate",
        },
        density: { value: 1858, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.72, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "plastering materials" },
        description: {
          value: "gypsum plaster, lightweight aggregate, 13mm",
        },
        density: { value: 721, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 17.7, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "plastering materials" },
        description: {
          value: "gypsum plaster, lightweight aggregate on metal lath, 20mm",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 12.1, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "roofing" },
        description: {
          value: "asbestos-cement shingles",
        },
        density: { value: 1922, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 27, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "roofing" },
        description: {
          value: "asphalt rool roofing",
        },
        density: { value: 1121, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 36.9, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "roofing" },
        description: {
          value: "asphalt shingles",
        },
        density: { value: 1121, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 12.9, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "roofing" },
        description: {
          value: "built-up roofing, 10mm",
        },
        density: { value: 1121, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 17, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "roofing" },
        description: {
          value: "slate, 13mm",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 113.6, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "roofing" },
        description: {
          value: "wood shingles - pain or plastic film faced",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 6.02, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "siding materials (on flat surface)" },
        description: {
          value: "shingles, abestos-cement",
        },
        density: { value: 1922, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 27, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "siding materials (on flat surface)" },
        description: {
          value: "siding, wood, drop, 25mm",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 7.21, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "siding materials (on flat surface)" },
        description: {
          value: "siding, wood, plywood, 10mm, lapped",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 9.03, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "siding materials (on flat surface)" },
        description: {
          value: "siding, aluminium or steel, over sheathing, hollowbacked",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 9.14, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "siding materials (on flat surface)" },
        description: {
          value: "siding, insulating board-backend nominal, 10mm",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 3.12, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "siding materials (on flat surface)" },
        description: {
          value: "siding, insulating board-backend nominal, 10mm foil-fackend",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 1.93, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "siding materials (on flat surface)" },
        description: {
          value: "architectural glass",
        },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 56.8, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "woods" },
        description: {
          value: "maple, oak and similiar hardwoods",
        },
        density: { value: 721, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.159, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "woods" },
        description: {
          value: "fir, pine and similiar softwoods",
        },
        density: { value: 513, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 0.115, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "metals" },
        description: {
          value: "aluminium (1100)",
        },
        density: { value: 2739, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 221.5, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "metals" },
        description: {
          value: "steel, mild",
        },
        density: { value: 7833, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 43.3, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
      {
        material: { value: "metals" },
        description: {
          value: "steel, stainless",
        },
        density: { value: 7913, unit: "kg/m\u00b3" },
        thermal_conductivity: { value: 15.6, unit: "W/(mK)" },
        unit_conductance: { value: "-" },
      },
    ],
  },
  {
    id: "u_value_windows_doows",
    name: "u-values for various windows and doors",
    updatedAt: "2022-07-26",
    data: [
      {
        material: { value: "windows - wooden" },
        description: { value: "single-glazed" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 5, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "windows - wooden" },
        description: { value: "double-glazed" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 2.5, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "windows - wooden" },
        description: { value: "triple-glazed" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 1.9, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "windows - wooden" },
        description: { value: "triple-glazed, hermetic" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 1.7, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "windows - steel" },
        description: { value: "single-glazed" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 5.8, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "windows - steel" },
        description: { value: "double-glazed" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: "3.4 - 4.3", unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "windows - steel" },
        description: { value: "triple-glazed" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: "2.7 - 3.5", unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "doors - wooden, plastic" },
        description: { value: "internal single door, without glass" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 1.2, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "doors - wooden, plastic" },
        description: { value: "internal single door, with glass" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 2.4, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "doors - wooden, plastic" },
        description: { value: "external single door, without glass" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 1.3, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "doors - wooden, plastic" },
        description: { value: "external single door, with glass" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 3.4, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "doors - wooden, plastic" },
        description: { value: "external double door, without glass" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 0.7, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "doors - wooden, plastic" },
        description: { value: "external double door, with glass" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 1.7, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "doors - wooden, plastic" },
        description: { value: "balcony double door, 50% glass" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 2.1, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "doors - wooden, plastic" },
        description: { value: "balcony double door, 100% glass" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 2.4, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "doors - wooden, plastic" },
        description: { value: "balcony triple door, 50% glass" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 1.5, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "doors - wooden, plastic" },
        description: { value: "balcony triple door, 100% glass" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 1.7, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "doors - metal" },
        description: { value: "internal door" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 1.5, unit: "C,W/(m\u00b2K)" },
      },
      {
        material: { value: "doors - metal" },
        description: { value: "external door" },
        density: { value: "-" },
        thermal_conductivity: { value: "-" },
        unit_conductance: { value: 5, unit: "C,W/(m\u00b2K)" },
      },
    ],
  },
];
